export { Slider, type SliderOptions } from './Slider';
